import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import type {
  OrgVenueApi,
  OrgVenuesResponseApi,
} from '../../features/organization/registration/types'

const PER_PAGE = 100
/** Guards against a runaway `total_pages`; 2,000 venues is beyond any org. */
const MAX_PAGES = 20

/**
 * Every venue of an organization, all pages: the API ignores search and sort,
 * so a pick list searches and sorts the whole set itself. Any failing page
 * fails the read rather than leaving a partial list.
 * `GET /organizations/:id/venues`
 */
export const getOrgVenues = async (orgId: string): Promise<OrgVenueApi[]> => {
  const venues: OrgVenueApi[] = []

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const response: OrgVenuesResponseApi | undefined = await req(
      ENDPOINTS.ORGANIZATIONS.VENUES(orgId),
      { method: 'GET', query: { page, per_page: PER_PAGE } }
    )
    venues.push(...(response?.data ?? []))

    if (page >= Number(response?.meta?.pagination?.total_pages ?? 1)) {
      break
    }
  }

  return venues
}
